import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-pixel-tracking',
  templateUrl: './pixel-tracking.component.html',
  styleUrls: ['./pixel-tracking.component.scss'],
})
export class PixelTrackingComponent implements OnInit {
  @Input() pageName!: string;
  @Input() actionId!: number;
  @Input() siteID!: number;
  public url!: string;

  constructor() {}

  ngOnInit(): void {
    let cpid = window['wf_cpid'];
    let sid = this.getCookie('gts_kredit');
    let deviceOutput = window['wf_devicetype'];

    this.generateTrackingPixel(
      this.siteID,
      cpid,
      this.pageName,
      'at-kredit',
      sid,
      this.actionId,
      deviceOutput
    );
  }
  getCookie(name) {
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith(name + '='))
      ?.split('=')[1];
  }

  generateTrackingPixel(
    siteId: number,
    cpid: string,
    areaId: string,
    product: string,
    sid: string,
    actionId: number,
    deviceOutput: string
  ): void {
    this.url = 'https://asset42.check24.at/gif';

    if (siteId > 0) {
      this.url += '/site_id/' + siteId;
    }

    if (cpid.length > 0) {
      this.url += '/cpid/' + cpid;
    }

    if (areaId.length > 0) {
      this.url += '/area_id/' + areaId;
    }

    if (product.length > 0) {
      this.url += '/product/' + product;
    }

    if (sid?.length > 0) {
      this.url += '/sid/' + sid;
    }

    if (actionId > 0) {
      this.url += '/action_id/' + actionId;
    }

    if (deviceOutput.length > 0) {
      this.url += '/deviceoutput/' + deviceOutput.toLowerCase();
    }

    this.url += '/country/at/info.gif';
  }
}
